
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getRoleDisplayName } from '../../utils/helpers';
import { decodeJWT } from '../../utils/jwt';

const Header = ({ onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get token and decode agent info
  const token = sessionStorage.getItem('agentToken');
  const agent = decodeJWT(token);

  const handleLogout = () => {
    onLogout();
    sessionStorage.removeItem('agentActiveTab');
    navigate('/agent/login', { replace: true });
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/agent/dashboard">
            <h1>Muv Cargo</h1>
          </Link>
        </div>

        <nav className="nav">
          {token && agent ? (
            <div className="agent-nav">
              <div className="agent-info">
                <span className="agent-name">Welcome, {agent.fullName || agent.username}</span>
                <span className="agent-role">{getRoleDisplayName(agent.role)}</span>
                <button onClick={handleLogout} className="btn btn-sm btn-secondary">
                  Logout
                </button>
              </div>
            </div>
          ) : (
            <div className="public-nav">
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                Track Container
              </Link>
              <Link to="/agent/login" className="btn btn-sm btn-primary">
                Agent Login
              </Link>
            </div>
          )}
        </nav>
      </div>

  <style>{`
        .header {
          background: white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          padding: 1rem 0;
        }
        
        .header-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .logo h1 {
          color: #007bff;
          font-size: 1.5rem;
          margin: 0;
        }
        
        .logo a {
          text-decoration: none;
        }
        
        .nav a {
          margin-left: 1.5rem;
          text-decoration: none;
          color: #333;
          font-weight: 500;
        }
        
        .nav a:hover,
        .nav a.active {
          color: #007bff;
        }
        
        .agent-nav {
          display: flex;
          align-items: center;
          gap: 2rem;
        }
        
        .agent-info {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .agent-name {
          font-weight: 600;
        }
        
        .agent-role {
          background: #e9ecef;
          padding: 0.25rem 0.5rem;
          border-radius: 12px;
          font-size: 0.75rem;
          color: #6c757d;
        }
        
        .public-nav {
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }
        
        @media (max-width: 768px) {
          .header-container {
            flex-direction: column;
            gap: 1rem;
          }
          
          .agent-nav {
            flex-direction: column;
            gap: 1rem;
          }
          
          .agent-info {
            flex-direction: column;
            gap: 0.5rem;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;